// extracted by mini-css-extract-plugin
module.exports = {"message":"styles_message__1plH1","thanksMessageInput":"styles_thanksMessageInput__3xTC5","updateButton":"styles_updateButton__21Ulm","messageButton":"styles_messageButton__3Vgd9"};